"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IBeacon__factory", {
  enumerable: true,
  get: function get() {
    return _IBeacon__factory.IBeacon__factory;
  }
});
var _IBeacon__factory = require("./IBeacon__factory");